import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Icon from '../i/icons_d.png';

const styles = {
  bxPrev: {
    position: 'absolute',
    display: 'block',
    fontSize: '0',
    width: '33px',
    height: '26px',
    background: `url(${Icon}) no-repeat`,
    backgroundSize: '750px 340px',
    backgroundPosition: '-190px -107px',
    transform: 'rotate(180deg)',
    MsTransform: 'rotate(180deg)',
    WebkitTransform: 'rotate(180deg)',
    top: '217px',
    left: '-60px',
    outline: 'none',
    textDecoration: 'none',
  },
  bxNext: {
    position: 'absolute',
    top: '217px',
    right: '-60px',
    display: 'block',
    fontSize: '0',
    width: '33px',
    height: '26px',
    background: 'url(../i/icons_d.png) no-repeat',
    backgroundSize: '750px 340px',
    backgroundPosition: '-190px -107px',
    outline: 'none',
    textDecoration: 'none',
  },
  bxPager: {
    display: 'table',
    margin: 'auto',
    position: 'relative',
    top: '53px',
  },
  bxPagerItem: {
    float: 'left',
  },
  bxPagerLink: {
    display: 'block',
    width: '7px',
    height: '7px',
    fontSize: '0',
    backgroundColor: '#c2c2c2',
    borderRadius: '100%',
    margin: '1px 4px 0 0',
  },
  active: {
    backgroundColor: '#2b9cd8',
    width: '9px',
    height: '9px',
    margin: '0 4px 0 0',
  },
};
class Pager extends React.Component {
  state = {
    activePage: 1,
  }

  onChangePage = (activePage) => {
    this.setState({ activePage });
  }

  render() {
    const { classes, totalPages } = this.props;
    const { activePage } = this.state;
    return (
      <div>

        <div>
          <div className={classes.bxPrev}>Prev</div>
          <div className={classes.bxNext}>Next</div>
        </div>
        <div className={classes.bxPager}>
          {
            Array(totalPages).map((o, i) => {
              const linkClass = (activePage === i + 1)
                ? classNames(classes.bxPagerLink, classes.active) : classes.bxPagerLink;
              return (
                <div className={classes.bxPagerItem}>
                  <div role="presentation" onClick={() => this.onChangePage(i + 1)} data-slide-index={i} className={linkClass}>{i + 1}</div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Pager);

Pager.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  totalPages: PropTypes.number,
};

Pager.defaultProps = {
  classes: {},
  totalPages: 4,
};
